// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"311":"61012016","453":"9a71e3a3","518":"90e9c151","599":"5439e1bc","660":"5f84e308","705":"e3279afe","825":"9e623cb3","945":"80e3e01a","996":"85ef9f26"}[chunkId] + ".chunk.js";
};